// src/components/tableros/tabs/PresetsTab.js
import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  Button,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  Alert
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';

const PresetsTab = ({
  configurations,
  selectedConfig,
  setSelectedConfig,
  configName,
  setConfigName,
  loadConfiguration,
  saveConfiguration,
  isMobile
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Paper variant="outlined" sx={{ p: 2, minHeight: 200 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Cargar Configuración
          </Typography>
          
          {configurations.length > 0 ? (
            <>
              <InputLabel id="select-config-label" sx={{ mb: 1 }}>
                Seleccionar Preset Guardado
              </InputLabel>
              <Select
                labelId="select-config-label"
                value={selectedConfig}
                onChange={(e) => {
                  setSelectedConfig(e.target.value);
                  loadConfiguration(e.target.value);
                }}
                fullWidth
                size="small"
                sx={{ mb: 2 }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>Ninguno</em>
                </MenuItem>
                {configurations.map((config) => (
                  <MenuItem key={config.id} value={config.id}>
                    {config.name}
                  </MenuItem>
                ))}
              </Select>
              
              {configurations.length > 0 && (
                <Alert severity="success" sx={{ mt: 2 }}>
                  {configurations.length} configuración(es) disponible(s)
                </Alert>
              )}
            </>
          ) : (
            <Alert severity="info" sx={{ mb: 2 }}>
              No hay configuraciones guardadas
            </Alert>
          )}
        </Paper>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Paper variant="outlined" sx={{ p: 2, minHeight: 200 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Guardar Configuración Actual
          </Typography>
          <TextField
            label="Nombre de la configuración"
            value={configName}
            onChange={(e) => setConfigName(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
            sx={{ mb: 2 }}
            placeholder="Ej: Configuración para Carreras de Velocidad"
          />
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={saveConfiguration}
            disabled={!configName.trim()}
            fullWidth
          >
            Guardar Configuración
          </Button>
          
          <Alert severity="info" sx={{ mt: 2 }}>
            Las configuraciones se guardan en el navegador. Puedes exportarlas e importarlas para compartirlas.
          </Alert>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default PresetsTab;